import React, { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { Alert } from 'antd';

export default function useFeedbackHandler(
  props = {
    renderErrors: true,
    renderToasts: false,
  },
) {
  const { renderErrors, renderToasts } = props;

  const [feedback, setFeedback] = useState({
    message: '',
    type: '',
  });

  const renderFeedbackToast = () => {
    if (!feedback.message) {
      return null;
    }

    if (feedback.type === 'error') {
      return toast.error(feedback.message, {
        autoClose: false,
      });
    }

    return toast(feedback.message, {
      autoClose: false,
    });
  };

  function resetFeedback() {
    setFeedback({
      message: '',
      type: '',
    });
  }

  const renderFeedbackLabel = useMemo(
    () =>
      Boolean(feedback?.message) &&
      Boolean(feedback?.type) && (
        <div className="mt-md">
          <Alert
            showIcon
            title={feedback.message}
            description={
              renderErrors &&
              feedback?.errors && (
                <ul className="list-disc">
                  {Object.values(feedback.errors).map((error, index) =>
                    error ? <li key={`error-${index}`}>{error}</li> : null,
                  )}
                </ul>
              )
            }
            type={feedback.type}
            errors={renderErrors ? feedback?.errors : undefined}
          />
        </div>
      ),
    [feedback, renderErrors],
  );

  useEffect(() => {
    if (renderToasts) {
      renderFeedbackToast();
    }
  }, [renderToasts, feedback]);

  return {
    feedback,
    setFeedback,
    resetFeedback,
    renderFeedbackLabel,
    renderFeedbackToast,
  };
}
